const { CJDropshippingApp, CJDropshippingRoutes } = require("./CJDropshippingApp");
const { CJDropshippingProvider, useCJDropshipping } = require("./context/CJDropshippingContext");
const { createCJDropshippingApi } = require("./api/cjDropshipping.api");
const { getCJDropshippingNavigation } = require("./navigation");
const { CJSyncModal } = require("./components/sync-wizard/CJSyncModal");
const { CJ_DROPSHIPPING_CSS } = require("./styles");
const routes = require("./routes");

module.exports = {
  CJDropshippingApp,
  CJDropshippingRoutes,
  CJDropshippingProvider,
  useCJDropshipping,
  createCJDropshippingApi,
  getCJDropshippingNavigation,
  // Assistant de synchronisation 3 étapes, ré-exporté ici pour être
  // consommable depuis src/ (ex: editProduct.jsx) via le spécificateur de
  // package "@elakay/cj-dropshipping" -- un import relatif direct
  // (../../../../dropShipping/CJDropshipping/...) est bloqué par le
  // ModuleScopePlugin de react-scripts (aucun import relatif hors de src/
  // n'est autorisé), alors qu'un import résolu via node_modules/ (même
  // symlinké) ne l'est pas.
  CJSyncModal,
  // Normalement injecté par DropshippingLayout.js (<style>{CJ_DROPSHIPPING_CSS}</style>),
  // qui enveloppe toutes les routes internes du module CJ Dropshipping --
  // mais editProduct.jsx (usage inline de CJSyncModal) ne monte jamais ce
  // layout, donc aucune règle cjwiz-*/cjds-* n'atteignait la page (tout le
  // wizard s'affichait sans aucun style). Ré-exporté ici pour que
  // editProduct.jsx puisse l'injecter lui-même, une seule fois.
  CJ_DROPSHIPPING_CSS,
  ...routes,
};
